import { useEffect, useMemo, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  Button,
  Typography
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
/*
  IMPORT YOUR THREE PNG IMAGES HERE
  Adjust paths if you choose a different folder
*/
import step1 from "../assets/quant-analytics/digital/step-1.png";
import step2 from "../assets/quant-analytics/digital/step-2.png";
import step3 from "../assets/quant-analytics/digital/step-3.png";
import step4 from "../assets/quant-analytics/digital/step-4.png";



export default function QuantAnalyticsCryptoModal({ open, onClose }) {
    // Define the 3-step flow (order matters)
    const steps = useMemo(
    () => [
        { label: "Strategic Asset Allocation", image: step1 },
        { label: "Asset Liability Modeling", image: step2 },
        { label: "Risk Factor Decomp & Risk Budgeting", image: step3 },
        { label: "Mkt Regime & Stress Testing", image: step4 }
    ],
    []
  );

  const [stepIndex, setStepIndex] = useState(0);

  // Reset to first step every time modal opens
  useEffect(() => {
    if (open) {
      setStepIndex(0);
    }
  }, [open]);

  const isFirst = stepIndex === 0;
  const isLast = stepIndex === steps.length - 1;

  const goNext = () => {
    if (!isLast) setStepIndex((prev) => prev + 1);
  };

  const goBack = () => {
    if (!isFirst) setStepIndex((prev) => prev - 1);
  };

  const currentStep = steps[stepIndex];

  return (
        <Dialog
          open={open}
          onClose={onClose}
          maxWidth={false}
          scroll="paper"
          sx={{ "& .MuiDialog-container": { alignItems: "flex-start", justifyContent: "center", pt: "72px", pb: 2 }, "& .MuiDialog-paper": { position: "relative", left: "clamp(-64px, calc((100vw - 768px) * -0.6), 0px)" } }}
          PaperProps={{
            sx: {
              width: "fit-content",
              maxWidth: "92vw",
              maxHeight: "90vh",
              margin: 0,
              display: "flex",
              flexDirection: "column",
              backgroundColor: "#010915",
              color: "#ffffff",
              overflowY: "auto"
            }
          }}
        >
      {/* ===== HEADER ===== */}
        <DialogTitle
          id="data-ingestion-dialog-title"
          sx={{ pr: 6, cursor: "move" }}
        >
        Quant Analytics — Crypto Fund
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: "#fff"          // ✅ makes the X visible
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      {/* ===== CONTENT ===== */}
        <DialogContent
          sx={{
            p: 2,
            overflowY: "auto",
            color: "inherit",
            scrollbarWidth: "thin"
          }}
        >
        {/* Step title */}
        <Typography
          variant="subtitle1"
          sx={{ fontWeight: 600, mb: 2 }}
        >
          Step {stepIndex + 1} of {steps.length}: {currentStep.label}
        </Typography>

        {/* Image */}
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
        <img
          src={currentStep.image}
          alt={currentStep.label}
          style={{
            maxWidth: "100%",
            maxHeight: "70vh",
            width: "auto",
            height: "auto",
            objectFit: "contain",
            display: "block"
          }}
        />
        </Box>

        {/* Navigation */}
        <Box
          sx={{
            mt: 3,
            display: "flex",
            alignItems: "center"
          }}
        >
          <Button
            variant="outlined"
            onClick={goBack}
            disabled={isFirst}
          >
            Back
          </Button>

          <Box sx={{ flex: 1 }} />

          {/* Step dots */}
          <Box sx={{ display: "flex", gap: 1 }}>
            {steps.map((_, idx) => (
              <Box
                key={idx}
                sx={{
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  backgroundColor:
                    idx === stepIndex ? "text.primary" : "grey.400"
                }}
              />
            ))}
          </Box>

          <Box sx={{ flex: 1 }} />

          <Button
            variant="contained"
            onClick={goNext}
            disabled={isLast}
          >
            Next
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
